module.exports = __webpack_public_path__ + "static/media/pdf_icon.0680deb4.png";